import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from "primereact/multiselect";
import { Toast } from 'primereact/toast';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Slider } from 'primereact/slider';
import Services from "../../service/Services";
import { CambiarFormatoFecha, isEqual } from "../Funciones";
import Cookies from "universal-cookie";
import axios from "axios";
const cookies = new Cookies();

const Block2 = ({ setProjectsProp, getClients, objectMonthlyReportDataProp, clientChangeProp, setClearDataProp, setProjectAssignmentsProp,
    clearDataProp, monthlyReportProp, projectsOfficialProp, userSelectedProp, readReportProp, listReportsUsersProp, dataUserProp,
    setProjectsUserSessionProp, dateStartRangeProp, dateEndRangeProp, loadingProp,
    setShowErrorProp, getClientProp }) => {

    const getServices = new Services()
    
    const [dateStart, setDateStart] = useState(null)
    const [dateEnd, setDateEnd] = useState(null)
    const toast = useRef(null);
    const [projectSessionService, setProjectSessionService] = useState([]);
    const [servicesProjects, setServicesProjects] = useState([]);
    const [servicesClientsProjectsUsers, setServicesClientsProjectsUsers] = useState([]);
    //Ejecutar servicios solo una vez
    useEffect(() => {
        const source = axios.CancelToken.source();
        getServices.getDataSpecificProject().then((data) => {
            if (data !== undefined) {
                setServicesProjects(data)
            }
        })
        getServices.getAsociacionProyectoUsuarioVigente().then(data => {
            if (data !== undefined) {
                /* console.log(data); */
                setServicesClientsProjectsUsers(data)
            }
        })
        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps


    var projectRangeDate = []
    useEffect(() => {
        let source;
        if ((monthlyReportProp === 'monthlyReportOtherOfficial' || monthlyReportProp === 'allMonthlyReportOfOfficial') && userSelectedProp.id !== '') {
            if (readReportProp === true) {
                if (listReportsUsersProp.length !== 0) {
                    source = axios.CancelToken.source()
                    var newProjects = servicesProjects?.filter(obj1 => JSON.parse(listReportsUsersProp[0].asignaciones).some(obj2 => isEqual(obj1, obj2)));
                    let equals = [];
                    servicesProjects?.forEach(x => {
                        JSON.parse(listReportsUsersProp[0].asignaciones).forEach(y => {
                            if (parseInt(x.id) === parseInt(y.id)) {
                                equals.push({
                                    id: x.id,
                                    project: x.nombreproyecto,
                                    dateStartValidity: x.fechainiciovigencia,
                                    dateEndValidity: x.fechafinvigencia,
                                    percentage: y.percentage
                                })
                            }
                        })
                    })
                    setArrayObjectProjects(equals)

                    var newValueProject = newProjects.map(item => {
                        return {
                            id: item.id,
                            project: item.nombreproyecto,
                            dateStartValidity: item.fechainiciovigencia,
                            dateEndValidity: item.fechafinvigencia,
                        }
                    })
                    const filterDate = newValueProject.filter(x => {
                        var fechaInicio = CambiarFormatoFecha(new Date(x.dateStartValidity))
                        var fechaFin = CambiarFormatoFecha(new Date(x.dateEndValidity))
                        return ((fechaInicio <= dateStart && fechaInicio <= dateEnd
                            && fechaFin >= dateStart && fechaFin >= dateEnd) ||
                            (fechaInicio >= dateStart && fechaInicio <= dateEnd && fechaFin >= dateStart && fechaFin >= dateEnd))
                    })

                    filterDate.forEach(x => {
                        projectRangeDate.push(x)
                    })

                    setProjectAssignmentsProp(equals)
                    setSelectedProject(projectRangeDate)
                    setProjectsProp(newValueProject)
                    setItemsSelectedProject(newValueProject.length)
                    getServices.getprojectUser(userSelectedProp.id).then((data) => {
                        if (data !== undefined) {
                            setProjectSessionService(data)
                            setProjectsUserSessionProp(data)
                        }
                    })
                }
            } else {
                setSelectedProject(null)
                setArrayObjectProjects([])
                setProjectSessionService(projectsOfficialProp)
                setProjectsUserSessionProp(projectsOfficialProp)
            }
        } else if (monthlyReportProp === 'ownMonthlyReport') {
            if (readReportProp === true) {
                if (listReportsUsersProp.length !== 0) {
                    let newProjectsOwn = servicesProjects?.filter(obj1 => JSON.parse(listReportsUsersProp[0].asignaciones).some(obj2 => isEqual(obj1, obj2)));
                    let equals = [];
                    servicesProjects?.forEach(x => {
                        JSON.parse(listReportsUsersProp[0].asignaciones).forEach(y => {
                            if (parseInt(x.id) === parseInt(y.id)) {
                                equals.push({
                                    id: x.id,
                                    project: x.nombreproyecto,
                                    dateStartValidity: x.fechainiciovigencia,
                                    dateEndValidity: x.fechafinvigencia,
                                    percentage: y.percentage
                                })
                            }
                        })
                    })
                    setArrayObjectProjects(equals)
                    var newValueProjectOwn = newProjectsOwn.map(item => {
                        return {
                            id: item.id,
                            project: item.nombreproyecto,
                            dateStartValidity: item.fechainiciovigencia,
                            dateEndValidity: item.fechafinvigencia,
                        }
                    })

                    const filterDate = newValueProjectOwn.filter(x => {
                        var fechaInicio = CambiarFormatoFecha(new Date(x.dateStartValidity))
                        var fechaFin = CambiarFormatoFecha(new Date(x.dateEndValidity))
                        return ((fechaInicio <= dateStart && fechaInicio <= dateEnd
                            && fechaFin >= dateStart && fechaFin >= dateEnd) ||
                            (fechaInicio >= dateStart && fechaInicio <= dateEnd && fechaFin >= dateStart && fechaFin >= dateEnd))
                    })
                    filterDate.forEach(x => {
                        projectRangeDate.push(x)
                    })
                    setProjectAssignmentsProp(equals)
                    setSelectedProject(projectRangeDate)
                    setProjectsProp(newValueProjectOwn)
                    setItemsSelectedProject(newValueProjectOwn.length)

                    const projectsTable = {}
                    const uniqueProjects = servicesClientsProjectsUsers?.filter(function (object) {
                        return projectsTable.hasOwnProperty(object.id) ? false : (projectsTable[object.id] = true)
                    })
                    setProjectSessionService(uniqueProjects)
                    setProjectsUserSessionProp(uniqueProjects)
                }
            } else if (objectMonthlyReportDataProp !== undefined) {
                if (objectMonthlyReportDataProp.asignaciones !== null) {

                    if (objectMonthlyReportDataProp.cliente.id === getClients?.id) {

                        let projects = servicesProjects?.filter(obj1 => JSON.parse(objectMonthlyReportDataProp.asignaciones).some(obj2 => isEqual(obj1, obj2)));

                        let equals = [];
                        servicesProjects?.forEach(x => {
                            JSON.parse(objectMonthlyReportDataProp.asignaciones).forEach(y => {
                                if (parseInt(x.id) === parseInt(y.id)) {
                                    equals.push({
                                        id: x.id,
                                        project: x.nombreproyecto,
                                        dateStartValidity: x.fechainiciovigencia,
                                        dateEndValidity: x.fechafinvigencia,
                                        percentage: y.percentage
                                    })
                                }
                            })
                        })
                        setArrayObjectProjects(equals)
                        var newValue = projects.map(item => {
                            return {
                                id: item.id,
                                project: item.nombreproyecto,
                                dateStartValidity: item.fechainiciovigencia,
                                dateEndValidity: item.fechafinvigencia,
                            }
                        })
                        const filterDate = newValue.filter(x => {
                            return ((x.dateStartValidity <= dateStart && x.dateStartValidity <= dateEnd
                                && x.dateEndValidity >= dateStart && x.dateEndValidity >= dateEnd) ||
                                (x.dateStartValidity >= dateStart && x.dateStartValidity <= dateEnd && x.dateEndValidity >= dateStart && x.dateEndValidity >= dateEnd))
                        })
                        filterDate.forEach(x => {
                            projectRangeDate.push(x)
                        })
                        setSelectedProject(projectRangeDate)
                        setProjectAssignmentsProp(equals)
                        setProjectsProp(newValue)
                        setItemsSelectedProject(newValue.length)

                        const projectsTable = {}
                        const uniqueProjects = servicesClientsProjectsUsers?.filter(function (object) {
                            return projectsTable.hasOwnProperty(object.id) ? false : (projectsTable[object.id] = true)
                        })
                        setProjectSessionService(uniqueProjects)
                        setProjectsUserSessionProp(uniqueProjects)
                    }else{
                        setProjectAssignmentsProp([])
                    }
                }
            } else {
                const projectsTable = {}
                const uniqueProjects = servicesClientsProjectsUsers?.filter(function (object) {
                    return projectsTable.hasOwnProperty(object.id) ? false : (projectsTable[object.id] = true)
                })
                setProjectSessionService(uniqueProjects)
                setProjectsUserSessionProp(uniqueProjects)
                setSelectedProject([])
                
                // Agregar llamada a getActividadesConProyectos para nuevo registro
                //if (getClients.id !== '') {
                   //const usuarioId = userSelectedProp.id || cookies.get('idColaborador');
                    //loadProjects();
                    
                   //const filterDate = [];
                    //getServices.getActividadesConProyectos(usuarioId, getClients.id, dateStart, dateEnd).then((actividades) => {
                       //const proyectosConActividades = actividades.map(actividad => {
                            //let proyecto = filterDate.find(p => parseInt(p.id) === parseInt(actividad.idProyecto));
                           //if (!proyecto) {
                                //proyecto = servicesProjects.find(p => parseInt(p.id) === parseInt(actividad.idProyecto));
                           // }
                            //if (!proyecto && typeof projectClient !== "undefined") {
                                //proyecto = projectClient.find(p => parseInt(p.id) === parseInt(actividad.idProyecto));
                            //}
                            //return {
                               // id: parseInt(actividad.idProyecto),
                               //// project: actividad.nombreProyecto,
                               // dateStartValidity: proyecto?.dateStartValidity || proyecto?.fechainiciovigencia || dateStart,
                               // dateEndValidity: proyecto?.dateEndValidity || proyecto?.fechafinvigencia || dateEnd
                            //};
                        //});
                       // setSelectedProject(proyectosConActividades);
                      //  setArrayObjectProjects(proyectosConActividades);
                      //  onProjectChange({value: proyectosConActividades});
                   // });
                //} else {
                    //setSelectedProject([]);
                //}
                setArrayObjectProjects([])
                setProjectAssignmentsProp([])
            }
        }

        if (dateStartRangeProp !== null && dateEndRangeProp !== null) {
            setDateStart(CambiarFormatoFecha(dateStartRangeProp))
            setDateEnd(CambiarFormatoFecha(dateEndRangeProp))
        }
        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, [objectMonthlyReportDataProp, monthlyReportProp, userSelectedProp, projectsOfficialProp, readReportProp, listReportsUsersProp, dateStartRangeProp, dateEndRangeProp, servicesProjects, servicesClientsProjectsUsers, getClients]); // eslint-disable-line react-hooks/exhaustive-deps
    const [isCalculating, setIsCalculating] = useState(false);

    const calcularDedicacion = async () => {
        if (monthlyReportProp === 'ownMonthlyReport') {
            if (readReportProp === true) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'El informe no se puede calcular, ya que actualmente se encuentra cerrado, comuníquese con el administrador para que habilite el informe',
                    life: 7000
                });
                return;
            }
            setIsCalculating(true)
            try {
                const idUsuario = parseInt(cookies.get('idColaborador'));
                const idcliente = (getClients.id);
                const proyectosSeleccionadosIds = selectedProject.map(proyecto => parseInt(proyecto.id));
                const filtro = {
                    idUsuario: idUsuario,
                    fecInicial: dateStart,
                    fecFinal: dateEnd,
                    idsProyectos: proyectosSeleccionadosIds,
                    idcliente: idcliente
                };
                
                const data = await getServices.CalcularDedicacion(filtro);
                const actualizados = arrayObjectProjects.map((proyecto) => {
                    const calculado = data.find(item => parseInt(item.idProyecto) === parseInt(proyecto.id));
                    return {
                        ...proyecto,
                        percentage: calculado ? calculado.porcentaje : proyecto.percentage
                    };
                });
                setArrayObjectProjects(actualizados);
                //setSelectedProject(actualizados);
                toast.current.show({
                    severity: 'success',
                    summary: 'Dedicación actualizada',
                    detail: 'La dedicación ha sido actualizada correctamente.',
                    life: 5000
                });
                
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Hubo un problema al calcular la dedicación.',
                    life: 5000
                });
            }
            setIsCalculating(false)
        }
    }
    // estado para guardar el array de objetos de los proyectos seleccionados
    
    const [arrayObjectProjects, setArrayObjectProjects] = useState([])
    // obtener datos del select proyecto
    const [selectedProject, setSelectedProject] = useState(null)
    //var projectClient = []
    const [proyectoFechaVigente, setProyectoFechaVigente] = useState([])

    const [isLoading, setIsLoading] = useState(false);
    

    const loadProjects = () => {
        setIsLoading(true);
        let projectClient = [];
    
        if (getClients.client !== '') {
            const result = projectSessionService.filter(object => {
                return parseInt(object.cliente.id) === getClients.id;
            });
    
            result.forEach(element => {
                projectClient.push({
                    id: element.id,
                    nombre: element.nombre,
                    fechainiciovigencia: element.fechainiciovigencia,
                    fechafinvigencia: element.fechafinvigencia
                });
            });
    
            projectClient.sort((a, b) => a.nombre.localeCompare(b.nombre));
        }
    
        // Nuevo filtro: incluir proyectos cuyo rango de vigencia se cruce con el rango del informe
        let proyectosVigentes = projectClient.filter(element => {
            return (
                element.fechainiciovigencia <= dateEnd && element.fechafinvigencia >= dateStart
            );
        });
    
        if (objectMonthlyReportDataProp !== undefined) {
            const alreadyRegistered = JSON.parse(objectMonthlyReportDataProp.asignaciones);
            const transformed = alreadyRegistered.map(project => ({
                id: project.id,
                nombre: project.project,
                fechainiciovigencia: project.dateStartValidity,
                fechafinvigencia: project.dateEndValidity
            }));
    
            transformed.forEach(project => {
                if (!proyectosVigentes.find(p => parseInt(p.id) === parseInt(project.id))) {
                    proyectosVigentes.push(project);
                }
            });
        }
        setIsLoading(false);
        setProyectoFechaVigente(proyectosVigentes);
        return proyectosVigentes;
    };

    const verificarProyectosConActividades = async (proyectos, usuarioId, clienteId, dateStart, dateEnd) => {
        setIsLoading(true);
        try {
          const actividades = await getServices.getActividadesConProyectos(
            usuarioId,
            clienteId,
            dateStart,
            dateEnd
          );
      
          const proyectosConActividades = actividades.map(actividad => {
            const proyectoId = parseInt(actividad.idProyecto);
            const proyecto = proyectos.find(p => parseInt(p.id) === proyectoId);
      
            return {
              id: proyectoId,
              project: actividad.nombreProyecto,
              dateStartValidity: proyecto?.fechainiciovigencia || dateStart,
              dateEndValidity: proyecto?.fechafinvigencia || dateEnd,
              percentage: 0 // Asigna 0 o recupera si tienes % almacenado
            };
          });
      
          if (proyectosConActividades.length > 0) {
            onProjectChange({ value: proyectosConActividades });
          }
        } catch (error) {
          console.error('Error verificando actividades:', error);
        }
        setIsLoading(false);
      };
    //console.log(loadProjects);
    var dateValidError = false
    var messageDateValidError = ''

    useEffect(() => {
        setIsLoading(true);
        const cargarProyectosYVerificarActividades = async () => {
            if (getClients.id !== '') {
                const proyectos = loadProjects();
                await verificarProyectosConActividades(
                    proyectos,
                    userSelectedProp.id || cookies.get('idColaborador'),
                    getClients.id,
                    dateStart,
                    dateEnd
                );
            }
        };
        setIsLoading(false);
    
        cargarProyectosYVerificarActividades();
    }, [getClients, dateStart, dateEnd, projectSessionService]);// eslint-disable-line react-hooks/exhaustive-deps

    if (getClients.id !== '') {
        if (readReportProp === false) {
            if (proyectoFechaVigente.length === 0) {
                dateValidError = true
                messageDateValidError = 'No existe un proyecto que se encuentre en el rango de fechas del periodo seleccionado'
            } else {
                dateValidError = false
                messageDateValidError = ''
            }
        }
    }
    const [projects, setProjects] = useState([])
    useEffect(() => {
        setProjects(proyectoFechaVigente.map(item => {
            const obj = { project: item.nombre, id: parseInt(item.id), dateStartValidity: item.fechainiciovigencia, dateEndValidity: item.fechafinvigencia }
            return obj
        }))

    }, [proyectoFechaVigente])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(projects!== null && selectedProject!== null && arrayObjectProjects !== null){            

            // Asegúrate de que selectedProject sea un array de IDs
            const selectedProjectIds = selectedProject.map(project => parseInt(project.id));
        
            arrayObjectProjects.forEach(obj => {
                const objId = parseInt(obj.id);
                if (!selectedProjectIds.includes(objId)) {                
                    // Buscar el objeto en `projects` y agregarlo a `selectedProject` si se encuentra
                  const projectToAdd = projects.find(project => project.id === objId);
                    if (projectToAdd) {
                        
                        // Actualizar el estado selectedProject agregando el nuevo proyecto
                       setSelectedProject(prevSelectedProject => [
                          ...prevSelectedProject,
                          projectToAdd
                       ]);
                   }
               }
            });
       }
    }, [projects,arrayObjectProjects,selectedProject]);
    
    const [itemsSelectedProject, setItemsSelectedProject] = useState(0);
    const onProjectChange = (e) => {
        setIsLoading(true); 
        if (e.value !== null) {
            const newValue = e.value.map(item => {
                const existing = arrayObjectProjects.find(p => p.id === item.id);
                return {
                    id: parseInt(item.id),
                    project: item.project || item.nombre,
                    percentage: existing ? existing.percentage : 0,
                    dateStartValidity: item.dateStartValidity || item.fechainiciovigencia,
                    dateEndValidity: item.dateEndValidity || item.fechafinvigencia
                };
            }).filter((item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
            );
    
            // Asegurar que los objetos tienen la estructura correcta para el MultiSelect
            const formattedValue = e.value.map(item => ({
                id: parseInt(item.id),
                project: item.project || item.nombre,
                dateStartValidity: item.dateStartValidity || item.fechainiciovigencia,
                dateEndValidity: item.dateEndValidity || item.fechafinvigencia
            }));

            setSelectedProject(formattedValue);
            setProjectsProp(newValue);
            setArrayObjectProjects(newValue);
            setProjectAssignmentsProp(newValue);
            setItemsSelectedProject(e.value.length);
        } else {
            setProjectsProp([]);
            setArrayObjectProjects([]);
            setSelectedProject([]);
            setProjectAssignmentsProp([]);
        }

        setClearDataProp(clearDataProp + 1);
        setIsLoading(false);
    };
    // columnas para el datatable responsive

    const dt = useRef(null);

    // armar objecto con datos del usuario en sesión para llenar la tabla 

    const fullName = cookies.get('nombre')
    const Position = cookies.get('cargo')
    var sessionUserObject
    if (dataUserProp.length !== 0) {
        sessionUserObject = [{
            fullName: dataUserProp[0].nombres + ' ' + dataUserProp[0].apellidos,
            Position: dataUserProp[0].cargo.cargo
        }]
    } else {
        sessionUserObject = [{
            fullName: fullName,
            Position: Position
        }]
    }

    //Validar porcentajes

    const formatCurrency = (value) => {
        return Math.round(value) + '%';
    }

    const calculatePercentage = () => {
        let total = 0;
        for (let arrayObjectProject of arrayObjectProjects) {
            total += arrayObjectProject.percentage;
        }   
        const totalRedondeado = Math.round(total);
        if (totalRedondeado !== 100) {
            setShowErrorProp(true)
            setShowError(true)
            setMenssageError('Los porcentajes no suman el 100%, distribuya nuevamente los porcentajes')
        }
        else {
            setShowErrorProp(false)
            setShowError(false)
            setMenssageError('')
        }
        return formatCurrency(total);
    }

    // componentes para la tabla lista de proyectos gestionados

    const [updatePercentage, setUpdatePercentage] = useState(arrayObjectProjects)
    const [render, setRender] = useState(0)

    const onCellEditComplete = (e) => {
        /* console.log(e) */
        setUpdatePercentage(e.props.value)
        setRender(render + 1)
        let { rowData, newValue, field, } = e;
        return rowData[field] = newValue;
    }

    const [showError, setShowError] = useState(false);
    const [menssageError, setMenssageError] = useState('');

    useEffect(() => {
        setProjectAssignmentsProp(updatePercentage)
    }, [render, updatePercentage]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setUpdatePercentage(arrayObjectProjects)
    }, [arrayObjectProjects])

    const percentageEditor = (props) => {
        return <>
            <h5 style={{ marginBottom: '13px' }}> {props.value} %</h5>
            <Slider value={props.value} onChange={(e) => {
                props.editorCallback(e.value)
            }} step={5} />
        </>
    }

    let headerGroup = <ColumnGroup>
        <Row>
            <Column header="Proyectos" field="project" rowSpan={3} />
        </Row>
        <Row>
            <Column header="Id" field="id" />
            <Column header="Porcentaje / Dedicación" field="percentage" />
        </Row>
    </ColumnGroup>;

    let footerGroup = <ColumnGroup>
        <Row>
            <Column footer="Total:" colSpan={2} footerStyle={{ textAlign: 'right' }} />
            <Column footer={calculatePercentage} />
        </Row>
    </ColumnGroup>;
    const header = () => {
        return (
            <>
                <div className="p-fluid p-formgrid p-grid" style={{ alignItems: 'baseline' }}>
                    <div style={{ display: 'contents' }} >
                        <div className="p-field p-col-12 p-md-3" style={{ marginTop: '5px' }}>
                            <label className="labels" >Proyectos:</label>
                            <MultiSelect value={selectedProject} options={projects} onChange={onProjectChange} placeholder="Seleccione un proyecto"
                                className={dateValidError ? "p-invalid" : 'p-column-filter'} emptyMessage="No hay resultados" name="project" optionLabel="project" showClear
                                maxSelectedLabels={3} selectedItemsLabel={`${itemsSelectedProject} Elementos Seleccionados`} disabled={readReportProp || loadingProp} filter
                            />
                            <p className="mensajeError">{dateValidError ? messageDateValidError : ""}</p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            <div className="datatable-responsive-demo">
                <h3 className="labels">Asignación</h3>
                <h4 className="labels" style={{ marginTop: '10px', marginBottom: '10px' }}>Colaborador:</h4>
                <div className="card">
                    <DataTable ref={dt} value={sessionUserObject} dataKey="id" className="p-datatable-responsive-demo">
                        <Column className="columna" field="fullName" header="Nombre completo" />
                        <Column className="columna" field="Position" header="Cargo " />
                    </DataTable>
                </div>
            </div>

            <div className="datatable-responsive-demo">
                <div className="card">
                    <DataTable ref={dt} value={arrayObjectProjects} header={header} className="p-datatable-responsive-demo" style={{ overflow: 'hidden' }}
                        editMode="cell" emptyMessage="No se registran datos" headerColumnGroup={headerGroup} footerColumnGroup={footerGroup}
                        loading={loadingProp || isLoading}
                    >
                        <Column className="columna" headerStyle={{ width: '160px' }} field="project" header="Proyecto" />
                        <Column className="columna" headerStyle={{ width: '160px' }} field="id" header="id" />
                        <Column className="columna" headerStyle={{ width: '160px' }} field="percentage" header="Porcentaje / Dedicación"
                            editor={readReportProp ? null : (props) => percentageEditor(props)} onCellEditComplete={onCellEditComplete}
                        />

                    </DataTable>
                    <Toast ref={toast} />
                    <Button
                        label={isCalculating ? "Calculando..." : "Calcular Dedicación"}
                        icon={isCalculating ? "pi pi-spin pi-spinner" : "pi pi-percentage"}
                        className="p-button-success"
                        onClick={calcularDedicacion}
                        disabled={isCalculating || arrayObjectProjects.length === 0}
                        style={{ display: arrayObjectProjects.length > 0 && monthlyReportProp === 'ownMonthlyReport'
                            ? 'inline-block'
                            : 'none'}}
                    />
                </div>
            </div>
            <div className="p-fluid p-formgrid p-grid" style={{ alignItems: 'baseline' }}>
                <div style={{ display: 'contents' }} >
                    <div className="p-field p-col-12 p-md-12" style={{ marginTop: '15px' }}>
                        {
                            showError === true ?
                                <Message severity="error" text={menssageError} />
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Block2